var React = require('react');

function FlashDriveOnlyIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M53.8191 20.25L53.8191 8.25L6.18057 8.25L6.18058 20.25C6.18058 23.5637 8.86687 26.25 12.1806 26.25L47.8191 26.25C51.1328 26.25 53.8191 23.5637 53.8191 20.25ZM44.9717 29.2501L44.9717 51.5963L15.0275 51.5963L15.0275 29.2501L44.9717 29.2501ZM38.9296 42.3434L38.9296 38.3738L32.5618 38.3738L32.5618 42.3434L38.9296 42.3434ZM27.5507 38.1627L27.5507 42.1322L21.1829 42.1322L21.1829 38.1627L27.5507 38.1627Z","fill":"var(--primary-colour)"}));
}

FlashDriveOnlyIconInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = FlashDriveOnlyIconInline;

FlashDriveOnlyIconInline.default = FlashDriveOnlyIconInline;
